import DTCScanServiceButton from "./DTCScanServiceButton"

export default  DTCScanServiceButton;
